import {I18nKeys} from '@multipass-i18n';
import {Menu, MenuItem} from '@multipass-ui-components';
import {LucideIcon, Monitor, Moon, Sun} from 'lucide-react';
import * as React from 'react';

import {AppearanceMode, I18nKey, ThemeService, useT} from '../../logic';

export interface AppearanceMenuProps {
    themeService: ThemeService;
}

const MODE_ICON: Record<AppearanceMode, LucideIcon> = {day: Sun, night: Moon, system: Monitor};
const MODE_LABEL_KEY: Record<AppearanceMode, I18nKey> = {
    day: I18nKeys.appearance.day,
    night: I18nKeys.appearance.night,
    system: I18nKeys.appearance.system,
};

export const AppearanceMenu: React.FunctionComponent<AppearanceMenuProps> = ({themeService}: AppearanceMenuProps) => {
    const t = useT();
    const [mode, setMode] = React.useState<AppearanceMode>(themeService.currentMode);
    const select = (next: AppearanceMode) => {
        themeService.setMode(next);
        setMode(next);
    };
    const TriggerIcon = MODE_ICON[mode];
    return (
        <Menu iconOnly heading={t(I18nKeys.appearance.title)} ariaLabel={`${t(I18nKeys.appearance.title)}: ${t(MODE_LABEL_KEY[mode])}`} triggerIcon={<TriggerIcon size={20}/>}>
            <MenuItem checked={mode === 'day'} onSelect={() => select('day')} icon={<Sun size={20}/>} label={t(I18nKeys.appearance.day)}/>
            <MenuItem checked={mode === 'night'} onSelect={() => select('night')} icon={<Moon size={20}/>} label={t(I18nKeys.appearance.night)}/>
            <MenuItem checked={mode === 'system'} onSelect={() => select('system')} icon={<Monitor size={20}/>} label={t(I18nKeys.appearance.system)} subLabel={t(I18nKeys.appearance.systemSub)}/>
        </Menu>
    );
};
